<template>
  <div class="tabData">
    <div class="tabCont">
      <el-row class="datalist" :class="stockFlag(i) ? 'stock':'nostock'" v-for="(i,index) in tabData" :key="index" @click.native="chooseProduct(i)">
        <el-col :span="24" :class="{'stockTips':(stockFlag(i))}" style="text-align:center">
          <img :src="i.mainImgUrl || defaultImg" alt v-if="leftTabType === 'proSale'">
          <img :src="defaultImg" alt v-else-if="leftTabType === 'voucher'">
          <img :src="i.serviceImgUrl || defaultImg" alt v-else>
          <div v-if="stockFlag(i)">库存不足</div>
        </el-col>
        <el-col :span="8" class="tag">
          <el-tag class="redT" v-if="(leftTabType !== 'proSale' && leftTabType !=='3') && (i.courseStyle == 1 || i.courseStyle == 3) && i.courseFrequency">{{i.courseFrequency+'次'}}</el-tag>
          <el-tag class="redT" v-if="(leftTabType !== 'proSale' && leftTabType !=='3') && (i.courseStyle == 2 || i.courseStyle == 3) && i.courseTime && i.timeUnit">{{i.courseTime+(i.timeUnit == 'mon'?'个月':(i.timeUnit == 'day'?'天':''))}}</el-tag>
          <el-tag class="redT" v-if="(leftTabType !== 'proSale' && leftTabType =='7') && (i.courseStyle == 2 || i.courseStyle == 3) && i.courseTime">{{i.courseTime | filterTyTime }}</el-tag>
          <el-tag class="redT" v-if="leftTabType == 'proSale'">{{i.specs}}</el-tag>
        </el-col>
        <el-col :span="24" v-if="leftTabType === 'proSale'">
          <h5>
            <span>{{i.productName && i.productName.substr(0,1)}}</span>
            {{i.productName && i.productName.substr(1)}}
          </h5>
        </el-col>
        <el-col :span="24" v-else>
          <h5>
            <span>{{i.serviceName && i.serviceName.substr(0,1)}}</span>
            {{i.serviceName && i.serviceName.substr(1)}}
          </h5>
          <el-row v-if="i.serviceSub && i.serviceSub.length > 0" class="serviceName">
              <el-popover trigger="hover" placement="top">
                  <span v-for="(m,index) in i.serviceSub" :key="index">{{m.serviceName}}{{i.serviceSub.length-1 == index ? '' : '，'}}</span>
                  <el-col slot="reference" class="myPros">
                      <span v-for="(m,index) in i.serviceSub" :key="index">{{m.serviceName}}{{i.serviceSub.length-1 == index ? '' : '，'}}</span>
                  </el-col>
              </el-popover>
          </el-row>
          <p v-else>--</p>
        </el-col>
        <el-col :span="24" class="proprice">
          <p class="red">¥{{Number(i.price)?Number(i.price).toFixed(2):'0.00'}}</p>
        </el-col>
      </el-row>
      <div class="noMessage" v-if="tabData.length == 0">
        暂无数据
      </div>

      <el-dialog :title="chooseName" :visible.sync="dialogTableVisible" :center="true" width="580px" class="dataChoose">
          <el-form ref="chooseForm" :model="chooseForm" :rules="rules" label-width="120px">
            <el-row>
              <el-col :span="3"><div class="seize"></div></el-col>
              <el-col :span="15">
                <el-form-item v-for="(i,index) in chooseForm.numLimit" :key="index" :prop="'numLimit.'+index+'.choosePro'" :rules="rules.numLimit.choosePro"  label="选择商品">
                  <el-select v-model="i.choosePro" placeholder="请选择商品"  @change="changeService(i.choosePro)"
                  >
                    <el-option :label="m.serviceName" :value="m.serviceId" v-for="(m,index) in limitsubData" :key="index" :disabled="chooseSubId.indexOf(m.serviceId) != -1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="dialogbtnOptions">
              <el-button class="darkBtn" @click.native="close">取消</el-button>
              <el-button class="redBtn" @click.native="onSubmit">确定</el-button>
            </el-row>
          </el-form>
      </el-dialog>

      <!-- <el-dialog
      title="转为公共套盒"
      :visible.sync="dialogstockVisible"
      :center="true"
      width="580px"
    >
      <publicBox :dialogType="dialogType" :serviceRow='serviceRow' :dialogstockVisible='dialogstockVisible' @closeDialog='closeDialog' @refreshList='refreshList'/>
    </el-dialog> -->
    </div>
  </div>
</template>
<script>
import publicBox from "@/components/businessManagementCenter/publicBox";
import defaultImg from "@/assets/images/store/default.png";
import {getPackageChildBase} from '@/api'
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  components: {
    publicBox
  },
  props: ['leftTabType',"tabData",'curchooseAll'],
  data() {
    const isvalidateStock = (rule, value, callback) => {
      setTimeout(() => {
        if (value && this.compareStock(value,this.myserviceTimes) === 'nostock') {
          callback(new Error("库存不足"));
        }else if (value && this.compareStock(value,this.myserviceTimes) === 'publicBox') {
          callback(new Error("公共套盒库存不足，请先转为公共套盒"));
        }else{
          callback();
        }
      },200);
    };
    return {
      data: '',
      chooseName:'',
      dialogTableVisible:false,
      chooseData:[],
      chooseId:[],
      chooseForm:{
        numLimit:[]
      },
      defaultImg,
      limitsubData:[],
      limitData:[],
      rules:{
        numLimit:{
          choosePro:[
            { required: true, message: "请选择选项", trigger: "change" },
            { validator: isvalidateStock }
          ]
        }
      },
      dialogstockVisible:false,
      dialogType:'',
      serviceRow:'',
      myserviceTimes:'',
      fatherServiceId:'',
      validityTime:[
        {value:0,name:'3天'},
        {value:1,name:'5天'},
        {value:2,name:'7天'},
        {value:3,name:'10天'},
        {value:4,name:'15天'},
        {value:5,name:'30天'},
        {value:6,name:'2个月'},
        {value:7,name:'3个月'},
        {value:8,name:'4个月'},
        {value:9,name:'5个月'},
        {value:10,name:'半年'},
        {value:11,name:'一年'}
      ],
    };
  },
  computed: {
    chooseSubId(){
      let subAll = [];
      for(let i of this.chooseForm.numLimit){
        subAll.push(i.choosePro);
      }
      return subAll;
    },
    compareStock(){
      return function(val,myserviceTimes){
        for(let m of this.tabData){
          for(let n of m.serviceSub){
            if(n.serviceId == val){
              // this.serviceRow = n;
                if(myserviceTimes > 0){
                  if(m.addType != 6 && m.addType != 7 && m.addType != 8){
                    if(n.needProd == 1 && ((!n.stockMap.availableCount || n.stockMap.availableCount <= 0) || (myserviceTimes > n.stockMap.availableCount))){
                      return 'nostock';//无库存
                    }
                  }
                }else{
                  if( n.needProd != 0){
                    return 'nostock';//无库存
                  }
                }
            }
          }
        }
      }
    },
    stockFlag(){
      return function(i){
        if(i.addType == 3){
          if(!i.packageNumberSelect || i.packageNumberSelect == i.serviceSub.length){
            for(let m of i.serviceSub){
              if(m.needProd == 1 && m.stockMap && (!m.stockMap.availableCount || m.stockMap.availableCount <= 0)){
                return m.needProd == 1 && m.stockMap && (!m.stockMap.availableCount || m.stockMap.availableCount <= 0);
                break;
              }
            }
          }
        }else if(!i.packageNumberSelect){
          if(i.addType == 10){
            // 零售
            return i.stockMap && (!i.stockMap.availableCount || i.stockMap.availableCount <= 0)
          }else if(i.addType == 20){
            // 体验券商品
            return i.stockMap && (!i.stockMap.publicCount || i.stockMap.publicCount <= 0)
          }else{
            return i.needProd == 1 && i.stockMap && (!i.stockMap.availableCount || i.stockMap.availableCount <= 0)
          }
        }
      }
    },
    maxStock(){
      return function(elData){
        if(elData.addType != 6&&elData.addType != 7&&elData.addType != 8){
          let stock = 0,arr = [];
          if((elData.addType == 4 && elData.packageNumberSelect > 0 ) || (elData.addType != 4 && elData.packageNumberSelect > 0 && elData.packageNumberSelect < elData.serviceSub.length)){
            // 做比较，取库存最小值
            for(let i of elData.serviceSub){
              if(elData.orderGoodsList && elData.orderGoodsList.indexOf(i.serviceId) !== -1){
                if(elData.addType == 3){
                  // 组合套餐是可用库存，体验券是公共库存
                  arr.push(i.stockMap?(i.stockMap.availableCount>=0?i.stockMap.availableCount:99):99);
                }else{
                  arr.push(i.stockMap?(i.stockMap.publicCount>=0?(Math.floor(i.stockMap.publicCount/elData.courseFrequency)):99):99);
                }
              }
            }
            return stock = arr.sort((a,b)=>{
              return a-b;
            })[0];
          }else if(elData.addType == 3){
            for(let i of elData.serviceSub){
              arr.push(i.stockMap?(i.stockMap.availableCount>=0?i.stockMap.availableCount:99):99);
            }
            return stock = arr.sort((a,b)=>{
              return a-b;
            })[0];
          }else if(elData.addType == 20){
            return elData.stockMap?(elData.stockMap.publicCount>=0?elData.stockMap.publicCount:99):99
          }else{
            return elData.stockMap?(elData.stockMap.availableCount>=0?elData.stockMap.availableCount:99):99
          }
        }else{
          return 99
        }
      }
    },
  },
  watch: {
    'dialogTableVisible'(val){
      if(val){
        setTimeout(()=>{
          this.$refs.chooseForm.clearValidate();
        })
      }
    }
  },
  methods: {
    chooseProduct(i){
      if(this.stockFlag(i)) return;
      if(((i.addType == 4 || i.addType == 9) && i.packageNumberSelect > 0 ) || (i.addType != 4 && i.packageNumberSelect > 0 && i.packageNumberSelect < i.serviceSub.length)){
        // 弹框
        this.chooseName = i.serviceName;
        this.fatherServiceId = i.serviceId;
        let limitNums = [];
        for(let m=0;m<i.packageNumberSelect;m++){
          limitNums.push({choosePro:''});
        }
        this.chooseForm.numLimit = limitNums;
        this.limitsubData = i.serviceSub;
        this.dialogTableVisible = true;
        this.limitData = $.extend(true,{},i);
      }else{
        // 选择商品
        this.chooseId = $.extend(true,[],this.curchooseAll.chooseId);
        this.chooseData = $.extend(true,[],this.curchooseAll.chooseData);
        if(this.leftTabType === 'proSale'){
          // 实体商品字段不一样
          if(this.chooseId.indexOf(i.productId) == -1){
            i.serviceName = i.productName;
            i.originalPrice = i.price?i.price:'0.00';
            i.goodsId = i.productId;
            i.goodsType = 2;
            i.maxStock = this.maxStock(i);
            // 新增计算价格字段
            i.salePrice = i.price?i.price:'0.00';
            i.nofloatPrice = i.price?i.price:'0.00';
            i.nofloatDiscoutPrice = 0;
            i.nofloatsSmallsPrice = 0;
            i.nofloatforSalePrice = 0;

            this.chooseData.push(i);
            this.chooseId.push(i.productId);
            this.$set(i,'saleNumber',1);//默认商品数量是1
          }else{
            let _this = this;
            _this.chooseId.forEach(function(m, index) {
              if(m === i.productId){
                _this.chooseData[index].saleNumber ++ ;//数量相加
              }
            })
          }
        }else{
          if(this.chooseId.indexOf(i.serviceId) == -1){
            i.originalPrice = i.price;
            i.maxStock = this.maxStock(i);
            // 新增计算价格字段
            i.salePrice = i.price;
            i.nofloatPrice = i.price;
            i.nofloatDiscoutPrice = 0;
            i.nofloatsSmallsPrice = 0;
            i.nofloatforSalePrice = 0;

            this.chooseData.push(i);
            this.chooseId.push(i.serviceId);
            this.$set(i,'saleNumber',1);//默认商品数量是1
          }else{
            let _this = this;
            _this.chooseId.forEach(function(m, index) {
              if(m === i.serviceId){
                _this.chooseData[index].saleNumber ++ ;//数量相加
              }
            })
          }
        }
        this.$emit('chooseData',{
          chooseData:this.chooseData,
          chooseId:this.chooseId
        });
      }
    },
    close(){
      this.$message({
        type: "info",
        message: "已取消"
      });
      this.dialogTableVisible = false;
    },
    changeService(val){
      getPackageChildBase({
        fatherServiceId:this.fatherServiceId,
        serviceId:val
      }).then(res=>{
        if(res.code == 1){
          this.myserviceTimes =res.data.serviceTimes;
        }
        // this.myserviceTimes = res.data?(res.data[0]?res.data[0].serviceTimes:''):'';
        // if(this.compareStock(val,this.myserviceTimes) === 'publicBox'){
        //   // 转成公共套盒
        //   this.$confirm( '该套盒公共套盒用完了，是否转出一套为公共套盒', "提示", {
        //       distinguishCancelAndClose: true,
        //       confirmButtonText: '确认转出',
        //       cancelButtonText:'不转出',
        //       type: "warning"
        //   })
        //   .then(() => {
        //       this.dialogstockVisible = true;
        //       this.dialogType = 3;
        //   })
        //   .catch(action => {
        //     this.$message({
        //       type: "info",
        //       message: "已取消"
        //     });
        //   });
        // }
      })
    },
    closeDialog(val){
      this.dialogstockVisible = val;
    },
    refreshList(val){
      this.dialogstockVisible = val;
      this.dialogTableVisible = val;
      this.$emit("refreshData",false);
    },
    onSubmit(){
      this.$refs.chooseForm.validate(valid => {
          if (valid) {
            this.chooseId = $.extend(true,[],this.curchooseAll.chooseId);
            this.chooseData = $.extend(true,[],this.curchooseAll.chooseData);
            let chooseSubids = [];
            for(let i of this.limitData.serviceSub){
              if(this.chooseSubId.indexOf(i.serviceId) != -1){
                chooseSubids.push(i.serviceId);
              }
            }
            chooseSubids.push(this.limitData.serviceId);
            if(JSON.stringify(this.chooseId).indexOf(JSON.stringify(chooseSubids)) == -1){
              let curTotalName='';
              for(let i of this.limitData.serviceSub){
                if(this.chooseSubId.indexOf(i.serviceId) != -1){
                  curTotalName += i.serviceName +(this.chooseSubId.indexOf(i.serviceId) == this.chooseSubId.length-1 ? '':'，');
                }
              }
              this.limitData.totalName = this.limitData.serviceName+'('+ curTotalName +')';
              this.limitData.orderGoodsList = this.chooseSubId;//结算时候所选id
              this.limitData.originalPrice = this.limitData.price;
              this.limitData.maxStock = this.maxStock(this.limitData);
              // 新增计算价格字段
              this.limitData.salePrice = this.limitData.price;
              this.limitData.nofloatPrice = this.limitData.price;
              this.limitData.nofloatDiscoutPrice = 0;
              this.limitData.nofloatsSmallsPrice = 0;
              this.limitData.nofloatforSalePrice = 0;

              this.chooseData.push(this.limitData);
              this.chooseId.push(chooseSubids);
              this.$set(this.limitData,'saleNumber',1);//默认商品数量是1
            }else{
              let _this = this;
              _this.chooseId.forEach(function(i, index) {
                if(JSON.stringify(i) === JSON.stringify(chooseSubids)){
                  _this.chooseData[index].saleNumber ++ ;//数量相加
                }
              })
            }
            this.$emit('chooseData',{
              chooseData:this.chooseData,
              chooseId:this.chooseId
            });
            this.dialogTableVisible = false;
          } else {
              console.log("error submit!!");
              return false;
          }
      })
    }
  }
};
</script>
<style lang="less" scoped>
.tabData {
  height: 610px;
  padding: 20px 0 20px 4%;
  .tabCont{
    height: 570px;
    overflow-y: auto;
    .noMessage{
      height: 100%;
      background: url(../../assets/images/store/img_vip_none.png) no-repeat center 160px;
      background-size: 240px auto;
      text-align: center;
      color: #666;
      padding-top: 360px;
    }
  }
  .datalist {
    width: 23%;
    min-height: 165px;
    height: 185px;
    margin-left: 2%;
    box-shadow: 0px 0px 10px 0px rgba(65, 67, 85, 0.1);
    border-radius: 10px;
    display: inline-block;
    margin-bottom: 8px;
    padding: 12px;
    cursor: pointer;
    position: relative;
    text-align: center;
    &:nth-child(4n+1) {
      margin-left: 0;
    }
    .tag{
      position:absolute;
      right: 12px;
      top: 12px;
      text-align: right
    }
    img {
      width: 55%;
      // max-width: 75px;
      height: 60px;
      border-radius: 5px;
    }
    h5 {
      color: #444;
      font-size: 14px;
      font-weight: bold;
      width: 100%;
      max-height: 46px;
      overflow: hidden;
      span {
        font-size: 17px;
      }
    }
    .serviceName {
      color: #999;
      font-size: 13px;
      .myPros{
        width: 100%;
        height: 40px;
        overflow: hidden;
      }
    }
    .redT {
        height: 20px;
        line-height: 18px;
        padding: 0 4px;
        background: #f96479;
        border-radius: 0px 10px 10px 10px;
        color: #fff;
        margin-bottom: 8px;
      }
    .proprice {
      text-align: center;
      font-weight: bold;
      line-height: 30px;
    }
    &.nostock{
      &:hover {
        background: #f96479;
        h5 {
          color: #fff;
        }
        .serviceName {
          color: #fff;
        }
        .redT {
          background: #fff;
          color: #F96479;
        }
        .proprice {
          .red {
            color: #fff;
          }
        }
      }
    }
    &.stock{
      background: rgba(0,0,0,.1);
      h5,.grey{color: #999;}
      .redT{background: #B2B2B4;}
      .stockTips{
        position: relative;
        div{
          width: 56%;
          height: 60px;
          border-radius: 5px;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          text-align: center;
          background: rgba(255,255,255,.5) url(../../assets/images/store/icon_warn.png) no-repeat center 10px;
          padding-top: 32px;
          font-weight: bold;
          color: #F96479;
        }
      }
    }
  }
}
</style>
<style lang="less">
.tabData{
  .el-dialog__title {
    font-weight: bold;
  }
  .el-textarea__inner{
    height: 100%;
    border-radius: 18px;
  }
  .seize {
    height: 20px;
  }
  .el-button.redBtn {
    background: #F83B56;
    color: #fff;
  }
  .el-button.darkBtn {
    background: #3b404f;
    color: #fff;
  }
  .dialogbtnOptions {
    margin-top: 26px;
    text-align: center;
    .el-button {
      min-width: 105px;
      height: 38px;
      border:none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/operatingFloor/dataList.vue